/* eslint-disable */
export enum navBarLocalisationKeys {
  SWITCH_CUSTOMER = 'SWITCH_CUSTOMER',
  LOG_OUT = 'LOG_OUT',
  RESERVATION_UPLOAD = 'RESERVATION_UPLOAD',
  LEAVE_PAGE = 'LEAVE_PAGE',
  CANCEL = 'CANCEL',
  CONFIRM = 'CONFIRM'
}

export const enNavBarLocalisationMessages = {
  [navBarLocalisationKeys.SWITCH_CUSTOMER]: `Switch customer`,
  [navBarLocalisationKeys.LOG_OUT]: `Log out`,
  [navBarLocalisationKeys.RESERVATION_UPLOAD]: `Reservation Upload`,
  [navBarLocalisationKeys.LEAVE_PAGE]: `Are you sure you want to navigate to Home page?`,
  [navBarLocalisationKeys.CANCEL]: `Cancel`,
  [navBarLocalisationKeys.CONFIRM]: `Confirm`
}
